<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">采购商品<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="采购时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

            <div class="content-input-item">
              <label>供应商</label>
              <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>品牌</label>
              <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
<!--              <label>供应商</label>-->
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editTypeListDialog(-1, 0)" size="default">新建分类</el-button>
            <el-button type="success" @click="editPurchaseDialog(-1)" size="default">采购商品</el-button>
            <el-button type="warning" @click="putStorage" size="default">提交入库</el-button>
            <el-button type="danger" @click="storageList" size="default">入库记录</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <el-row :gutter="12">
          <el-col :sm="5" :md="4" :lg="3">
            <div class="type-list">
              <div class="type-list-title">
                <span>商品分类</span>
                <el-button type="text" @click="allTypeList">全部</el-button>
              </div>

              <el-tree :data="typeList" :props="defaultProps" @node-click="handleNodeClick" style="margin: 8px 16px 12px 12px;">
                <template #default="{ node, data }">
                <span class="custom-tree-node">
                  <span>{{ node.label }}</span>
                  <span>

                    <el-dropdown @command="commandParent">
                      <span class="el-dropdown-link">
                        <ElIcons v-if="node.level == 1" name="MoreFilled" color="#cccccc"/>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item :command="{type: 1,idx: -2, preId: data.id}">新建子分类</el-dropdown-item>
                          <el-dropdown-item :command="{type: 2,idx: 1, preId: 0, data: data}">编辑</el-dropdown-item>
                          <el-dropdown-item :command="{type: 3, data: data}">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>

                    <el-dropdown @command="commandParent">
                      <span class="el-dropdown-link">
                        <ElIcons v-if="node.level == 2" name="MoreFilled" color="#cccccc"/>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item :command="{type: 2,idx: 1, preId: node.parent.data.id, data: data}">编辑</el-dropdown-item>
                          <el-dropdown-item :command="{type: 3, data: data}">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <!--                    <a @click="append(data)"> Append </a>-->
                    <!--                    <a style="margin-left: 8px" @click="remove(node, data)"> Delete </a>-->
                  </span>
                </span>
                </template>
              </el-tree>
            </div>
          </el-col>
          <el-col :sm="19" :md="20" :lg="21">
            <div class="content-table" style="flex: 1; width: 100%">
              <el-table
                  ref="multipleTableRef"
                  :data="pageDataList"
                  v-loading="listLoading"
                  @selection-change="selsChange"
                  @header-click="selsAll"
                  @cell-click="toggleSelection"
                  size="default"
                  style="width: 100%"
                  border
              >
<!--                <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
                <el-table-column property="updateTime" label="入库时间" v-if="checkColList.indexOf('入库时间') > -1"/>
                <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1" width="90"/>
                <el-table-column property="" label="入库货单" v-if="checkColList.indexOf('入库货单') > -1" width="106" class-name="cursor">
                  <template #default="scope">
<!--                    <el-image class="item-img" fit="cover" :src="scope.row.waybillSmallImg" @click="showImg(scope.row.waybillImg)">-->
<!--                      <template #error>-->
<!--                        <div class="el-img-error">暂无图片</div>-->
<!--                      </template>-->
<!--                    </el-image>-->
                    <div v-if="scope.row.stockImgList.length > 0" class="cursor" @click="userImgList(scope.row.stockImgList)">
                      <el-image class="item-img" fit="fill" :src="scope.row.stockImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    </div>
                    <div v-else>
                      <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="numberNo" label="关联批次号" v-if="checkColList.indexOf('关联批次号') > -1" width="96"/>
                <el-table-column property="supplierName" label="供应商" v-if="checkColList.indexOf('供应商') > -1"/>
                <el-table-column property="brandName" label="品牌" v-if="checkColList.indexOf('品牌') > -1"/>
                <el-table-column property="commodityName" label="商品名称" v-if="checkColList.indexOf('商品名称') > -1"  width="90"/>
                <el-table-column property="" label="商品图片" v-if="checkColList.indexOf('商品图片') > -1" width="100">
                  <template #default="scope">
                    <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row.commodityImgList)">
                      <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    </div>
                    <div v-else>
                      <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="commodityTypeName" label="商品分类" v-if="checkColList.indexOf('商品分类') > -1"  width="90">
                  <template #default="scope">
                    {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
                  </template>
                </el-table-column>
                <el-table-column property="specification" label="商品规格" v-if="checkColList.indexOf('商品规格') > -1"  width="90"/>
                <el-table-column property="measureUnitName" label="计量单位" v-if="checkColList.indexOf('计量单位') > -1"  width="90"/>
                <el-table-column property="price" label="进货单价" v-if="checkColList.indexOf('进货单价') > -1"  width="90"/>
                <el-table-column property="retailPrice" label="建议零售价" v-if="checkColList.indexOf('建议零售价') > -1" width="96"/>
                <el-table-column property="num" label="采购数量" v-if="checkColList.indexOf('采购数量') > -1"  width="90"/>

                <el-table-column property="giveNum" label="赠送数量" v-if="checkColList.indexOf('赠送数量') > -1"  width="90"/>
                <el-table-column property="" label="入库数量" v-if="checkColList.indexOf('入库数量') > -1"  width="90" fixed="right">
                  <template #default="scope">
                    {{ scope.row.num + scope.row.giveNum }}
                  </template>
                </el-table-column>
                <el-table-column property="reduceMoney" label="优惠金额" v-if="checkColList.indexOf('优惠金额') > -1"  width="90"/>
                <el-table-column property="stockSum" label="入库总计" v-if="checkColList.indexOf('入库总计') > -1"  width="90" fixed="right">
                  <template #default="scope">
<!--                    {{ Number(scope.row.num)*Number(scope.row.price) }}-->
                    {{scope.row.stockSum}}
                  </template>
                </el-table-column>
                <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1" fixed="right">
                  <template #default="scope">
                    <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'待入库':scope.row.state == 2?'已驳回':scope.row.state == 3?'已入库':'' }}</p>
                  </template>
                </el-table-column>
                <!--            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"/>-->
                <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="84" fixed="right">
                  <template #default="scope">
                    <el-space wrap>

                      <el-button v-if="scope.row.state == 3" @click="editPurchaseDialog(scope.$index,scope.row)" size="small" type="success">查看</el-button>
                      <el-button v-else @click="editPurchaseDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                      <el-button @click="delPurchase(scope.$index,scope.row)" size="small" type="danger">撤销</el-button>
                    </el-space>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {listAllSupplier,listAllBrand, getPurchaseCommodityPageList, updateCommodityState, listAllCommodityType, updateCommodityTypeDel, updatePurchaseCommodityDel} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import DatePickerRange from "@/components/DatePickerRange_30";
import ImgViewer from '@/assets/js/imageViewer'
import TypeListDialog from "@/views/commodity/components/TypeListDialog";
import PurchaseDialog from "@/views/commodity/components/PurchaseDialog";
import PutStorageDialog from "@/views/commodity/components/PutStorageDialog";
import StorageListDialog from "@/views/commodity/components/StorageListDialog";
import unLock from "@/layout/components/unLock";
import { mul, Number_SubAll } from "@/assets/shared/util";

export default {
  name: "CommodityPurchase",
  components: { BtnGroup, SearchComponents, DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      limitState: false,

      shopIdArray: [],
      shopIdArr:[],
      shopId: '',

      stateArray: [
        {label: '不限', value: -1},
        {label: '待提交', value: 0},
        {label: '待入库', value: 1},
        {label: '已驳回', value: 2},
        {label: '已入库', value: 3},
      ],
      state: -1,

      //刷新组
      colList: ['入库时间', '所属门店', '入库货单', '关联批次号', '供应商', '品牌','商品名称', '商品图片', '商品分类', '商品规格', '计量单位', '进货单价', '建议零售价', '采购数量', '赠送数量', '入库数量', '优惠金额', '入库总计', '状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '商品名称', value : 1},
        {label : '批次号', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      idArray: [],

      typeList: [],
      defaultProps: {
        children: 'subTypeList',
        label: 'name'
      },
      commodityTypeId: 0,

    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.state = -1;
      // this.shopId = -1;
      this.limitState = false;
      this.brandId = 0;
      this.supplierId = 0;
      this.commodityTypeId = 0;
      this.searchType = 1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    handleNodeClick(data) {
      // console.log(data);
      this.commodityTypeId = data.id
      this.getPage()
    },

    getTreeMore(node) {
      console.log(node.level)
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },

    putStorage() {
      // if(this.idArray.length == 0) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请先选择需要提交入库的商品',
      //     type: 'warning'
      //   });
      //   return false
      // }
      // let _title = '提交入库';
      // let purchaseList = []
      // for(let i=0; i<this.idArray.length; i++) {
      //   for(let j=0; j<this.pageDataList.length; j++) {
      //     if(this.idArray[i] == this.pageDataList[j].id) {
      //       if(this.pageDataList[j].state != 0) {
      //         this.$message({
      //           showClose: true,
      //           duration: 2000,
      //           message: '只能选择【待提交】状态的商品',
      //           type: 'warning'
      //         });
      //         return false
      //       }else {
      //         purchaseList.push(this.pageDataList[j])
      //       }
      //     }
      //   }
      // }
      Dialog.open({
        title: '提交入库',
        component: PutStorageDialog,
        data: {
          purchaseList: [],
          storageForm: {},
          ids: -1,
          shopId: this.shopId,
          width: '670px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    storageList() {
      let _title = '入库记录';
      Dialog.open({
        title: _title,
        component: StorageListDialog,
        data: {
          width: '1200px',
        },
        close: (result) => {
          this.getPage()
        }
      })
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['limitState'] = this.limitState?1:0;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.shopId;
      param['commodityTypeId'] = this.commodityTypeId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPurchaseCommodityPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            item.stockSum = Number_SubAll( mul(item.num, item.price), item.reduceMoney )
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editPurchaseDialog(idx, row) {
      let _title = '';
      let purchaseForm = {}
      if (idx > -1) {
        _title = '编辑采购单'
        purchaseForm = Object.assign({}, row);
        // console.log(purchaseForm)
      }else {
        _title = '采购商品'
        // console.log(purchaseForm)
      }
      Dialog.open({
        title: _title,
        component: PurchaseDialog,
        data: {
          purchaseForm: purchaseForm,
          ids: idx,
          shopId: this.shopId,
          width: '670px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    allTypeList() {
      this.commodityTypeId = 0
      this.getPage()
    },

    commandParent(e) {
      console.log(e)
      //新建子分类
      if(e.type == 1) {
        this.editTypeListDialog(e.idx, e.preId)
      }
      //编辑
      if(e.type == 2) {
        this.editTypeListDialog(e.idx, e.preId, e.data)
      }
      //删除
      if(e.type == 3) {
        this.delCommodityType(e.data)
      }
    },

    editTypeListDialog(idx, preId, row) {
      console.log(row)
      let _title = '';
      let typeForm = {}
      if (idx > -1) {
        _title = '编辑分类'
        typeForm = Object.assign({}, row);
      }else if(idx == -1) {
        _title = '添加分类'
      }else if(idx == -2) {
        _title = '添加子分类'
      }
      Dialog.open({
        title: _title,
        component: TypeListDialog,
        data: {
          typeForm: typeForm,
          ids: idx,
          width: '500px',
          preId: preId,
        },
        confirm: (result) => {
          this.getCommodityTypeList()
        }
      })
    },

    delCommodityType(data) {
      this.$confirm('确认删除分类【' + data.name + '】？').then(() => {
        postFormData(updateCommodityTypeDel, {id: data.id}).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getCommodityTypeList()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    },

    delPurchase(idx, row) {
      this.$confirm('确认撤销商品【' + row.commodityName + '】？').then(() => {
        postFormData(updatePurchaseCommodityDel, {id: row.id}).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    },


    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateCommodityState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    userImgList(imgList) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: imgList,
          // id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getCommodityTypeList() {
      getFormData(listAllCommodityType).then(data=> {
        this.typeList = []
        this.typeList = this.typeList.concat(data.data)
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getCommodityTypeList()
    this.getSupplierList()
    this.getBrandList()
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.shopId = this.shopIdArray[0].id
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}

.type-list {
  /*padding: 0;*/
  border: 1px solid #ebeef5;
  margin-right: 12px;
  width: 100%;
  flex-shrink: 0;
}

.type-list-title {
  /*margin: 4px 16px 12px;*/
  /*padding-bottom: 6px;*/
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  /*border-bottom: 1px solid #ebeef5;*/
  align-items: center;
  background-color: #f5f7fa;
}

.type-list-title span{
  font-weight: bold;
}

.custom-tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
